<template>
  <div>
    <div class="titleAfter">心态分布</div>
    <div class="item-status">分析结果：最佳状态</div>
    <div class="item-info">
      大脑状态极佳，能感受幸福感的均衡状态。心态心态非常稳定，积极对待每件事情并心存感激，不被外部刺激所动摇。会是一个
      静默恬淡愉悦和乐的一天。每天管理自己的心态，持续维持该状态。
    </div>
    <div class="item-echarts">
      <div ref="chartRef" style="width: 700px; height: 400px"></div>
    </div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { ref, reactive, onMounted } from "vue";
let chartInstance;
const chartRef = ref(null);
const option = {
  backgroundColor: "#fff",
  legend: {
    data: ["测量值", "参考值"],
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["0.21", "0.42", "0.64", "0.85", "1.06", "1.27", "1.49"],
  },
  yAxis: {
    type: "value",
  },
  series: [
    {
      name: "测量值",
      type: "line",
      stack: "Total",
      data: [
        0, 10, 12, 14, 20, 21, 24, 26, 28, 30, 32, 33, 120, 132, 101, 134, 90,
        230, 210,
      ],
      lineStyle: {
        color: "#37AAFD", // 蓝色
      },
    },
    {
      name: "参考值",
      type: "line",
      stack: "Total",
      data: [120, 132, 101, 134, 90, 230, 210],
      lineStyle: {
        color: "#ff0000", // 红色
      },
    },
  ],
};
const init = () => {
  chartInstance = echarts.init(chartRef.value);
  option && chartInstance.setOption(option);
};
onMounted(() => {
  init();
});
</script>

<style lang="scss" scoped>
.titleAfter {
  position: relative;
  font-weight: bold;
  color: #4aefff;
}
.titleAfter::after {
  content: "";
  position: absolute;
  left: -8px;
  top: 2px;
  width: 3px;
  height: 14px;
  background: #4aefff;
  border-radius: 38px 38px 38px 38px;
}
.item-status {
  margin: 10px 0 20px 0;
}
.item-info {
  line-height: 26px;
  margin-bottom: 20px;
}
</style>
